import { Injectable, inject } from '@angular/core';

import { ProfileAvailabilityService } from './jsonapi-services/profile-availability.service';
import { EventParticipationService } from './jsonapi-services/event-participation.service';
import { EventService } from './jsonapi-services/event.service';
import { InstrumentService } from './jsonapi-services/instrument.service';
import { MediaAssetService } from './jsonapi-services/media-asset.service';
import { MusicianService } from './jsonapi-services/musician.service';
import { ProfileAreaSubscriptionService } from './jsonapi-services/profile-area-subscription.service';
import { ProfilePerformanceAreaService } from './jsonapi-services/profile-performance-area.service';
import { StyleService } from './jsonapi-services/style.service';
import { UserService } from './jsonapi-services/user.service';

@Injectable({
  providedIn: 'root',
})
export class JsonapiBootstrapService {
  private readonly profileAvailabilityService = inject(ProfileAvailabilityService);
  private readonly eventService = inject(EventService);
  private readonly eventParticipationService = inject(EventParticipationService);
  private readonly instrumentService = inject(InstrumentService);
  private readonly mediaAssetService = inject(MediaAssetService);
  private readonly musicianService = inject(MusicianService);
  private readonly profileAreaSubscriptionService = inject(ProfileAreaSubscriptionService);
  private readonly profilePerformanceAreaService = inject(ProfilePerformanceAreaService);
  private readonly styleService = inject(StyleService);
  private readonly userService = inject(UserService);
  private initialized = false;

  public async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    }

    this.profileAvailabilityService.getService();
    this.eventService.getService();
    this.eventParticipationService.getService();
    this.instrumentService.getService();
    this.mediaAssetService.getService();
    this.musicianService.getService();
    this.profileAreaSubscriptionService.getService();
    this.profilePerformanceAreaService.getService();
    this.styleService.getService();
    this.userService.getService();

    this.initialized = true;
  }
}
